/**
 * Converts date string to timestamp
 * @param {*} strDate 
 * @returns 
 */
export function toTimestamp(strDate){
    const datum = Date.parse(strDate);
    return datum/1000;
 }